// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ImageBanner-container-Fglw_ {
    margin: 0 auto;
    max-width: 1274px;
    padding: 0 24px;
}

.ImageBanner-pageContainer-Tx7RU {
    padding-top: 48px;
}`, "",{"version":3,"sources":["webpack://./src/components/Home/ImageBanner/ImageBanner.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB","sourcesContent":[".container {\n    margin: 0 auto;\n    max-width: 1274px;\n    padding: 0 24px;\n}\n\n.pageContainer {\n    padding-top: 48px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ImageBanner-container-Fglw_`,
	"pageContainer": `ImageBanner-pageContainer-Tx7RU`
};
module.exports = ___CSS_LOADER_EXPORT___;
